export const trackCampaignEvent = (event, page, extra = {}) => {
  try {
    const search = new URLSearchParams(window.location.search);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/campaign/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event,
        page,
        utm_source: search.get('utm_source'),
        utm_campaign: search.get('utm_campaign'),
        utm_content: search.get('utm_content'),
        ...extra,
      }),
    }).catch(() => {});
  } catch (_) { /* tracking must never break the page */ }
};

export const registerUrlWithUtm = () => {
  const search = window.location.search;
  return `/register${search || ''}`;
};
